import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CreateUserInput } from '../v3-sign-up/models/create-user-input.interface';
import { environment } from './../../../../../../../environments/environment';
import { URL_NETWORK_SERVICE } from '@tgx/shared/services';

interface RegisterUserResponse {
  code?: string;
  description?: string;
}

interface ValidateUserRequest {
  userEmail: string;
}

@Injectable({
  providedIn: 'root',
})
export class SignupService {
  private http = inject(HttpClient);
  private httpBackend = inject(HttpBackend);
  private urlNetworkService = inject(URL_NETWORK_SERVICE);

  private httpWithoutInterceptor: HttpClient;
  constructor() {
    const httpBackend = this.httpBackend;

    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }

  registerUser(data: CreateUserInput): Observable<RegisterUserResponse> {
    return this.http.post<RegisterUserResponse>(`${environment.apis.network_service}signup/register-user`, data).pipe(
      map((response) => {
        if (response?.code) {
          throw response.description;
        }
        return response;
      }),
      catchError((error) => {
        return throwError(() => error.error || error || 'Internal server Error!');
      }),
    );
  }

  validateUser(body: ValidateUserRequest): Observable<boolean> {
    return this.httpWithoutInterceptor.post<boolean>(this.urlNetworkService + 'signup/validate-user', body);
  }
}
